import React from "react";

export const StatusBadge = ({ status, label }) => {
  const map = {
    active: "dot-success",
    in_progress: "dot-accent",
    planning: "dot-muted",
    commissioning: "dot-warning",
    maintenance: "dot-warning",
    closed: "dot-muted",
    open: "dot-error",
    waiting_client: "dot-warning",
    resolved: "dot-success",
    expiring: "dot-warning",
    expired: "dot-error",
    trial: "dot-accent",
    critical: "dot-error",
    high: "dot-warning",
    medium: "dot-accent",
    low: "dot-muted",
  };
  return (
    <span className="inline-flex items-center gap-2 px-2.5 py-1 bg-white/[0.04] border border-white/[0.08] rounded-sm text-[11px] font-mono uppercase tracking-[0.18em]">
      <span className={`status-dot ${map[status] || "dot-muted"}`} />
      {label}
    </span>
  );
};

export const PageHeader = ({ eyebrow, title, subtitle, action }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 reveal">
    <div>
      {eyebrow && <p className="tactical-label mb-3">{eyebrow}</p>}
      <h1 className="text-3xl lg:text-4xl tracking-tight font-medium text-white">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-white/60 max-w-2xl">{subtitle}</p>}
    </div>
    {action}
  </div>
);
